module.exports = __webpack_public_path__ + "static/img/logo.64c63286.png";